import {Component, OnInit} from '@angular/core';
import {formatRating, reviewCountLabel, ReviewSummary} from "../../models/review";
import {ReviewService} from "../../services/review/review.service";
import {ReviewCardComponent} from "../review-card/review-card.component";
import {StarRatingComponent} from "../star-rating/star-rating.component";

/** Newest approved reviews on the home page. Stays hidden until there is at least one. */
@Component({
    selector: 'app-testimonials',
    standalone: true,
    imports: [ReviewCardComponent, StarRatingComponent],
    template: `
        @if (summary && summary.reviews.length > 0) {
            <section class="bg-gray-50 px-5 py-12 lg:py-16">
                <div class="max-w-6xl mx-auto">
                    <h2 class="text-center text-2xl lg:text-4xl font-bold text-gray-900">Што велат купувачите</h2>
                    <p class="pt-2 flex flex-wrap items-center justify-center gap-2 text-gray-700">
                        <app-star-rating [rating]="summary.average" [sizeClass]="'text-xl'"></app-star-rating>
                        <span><strong>{{ formatRating(summary.average) }}</strong> од 5 · {{ reviewCountLabel(summary.count) }}</span>
                    </p>
                    <div class="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                        @for (review of summary.reviews; track review.id; let i = $index) {
                            <!-- Three on a phone - six stacked cards are a long scroll. -->
                            <app-review-card [review]="review" [compact]="true"
                                             [class.hidden]="i >= 3" [class.sm:block]="i >= 3"></app-review-card>
                        }
                    </div>
                </div>
            </section>
        }
    `
})
export class TestimonialsComponent implements OnInit {

    summary: ReviewSummary | null = null;

    protected readonly formatRating = formatRating;
    protected readonly reviewCountLabel = reviewCountLabel;

    constructor(private readonly reviewService: ReviewService) {
    }

    ngOnInit(): void {
        this.reviewService.latest(6).subscribe({
            next: summary => this.summary = summary,
            error: () => this.summary = null
        });
    }
}
